import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ButtonType } from '@src/components/Button'
import { LoadingSpinner } from '@src/components/Loaders/LoadingSpinner'
import { useOutletFulfilmentData } from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilmentData/useOutletFulfilmentData'
import { useBasketItems } from '@src/hooks/useBasketItems/useBasketItems'
import { useBasketOutletId } from '@src/hooks/useBasketOutletId'
import { useMarketplace } from '@src/hooks/useMarketplace'
import { convertToSlug } from '@src/utils/convertToSlug'

import {
  ButtonContainer,
  Container,
  StyledButton,
  Title,
  Underlay,
  SubTitle,
} from './MenuItemModalAlertStyles'
import { useOutletPageContext } from '../../OutletPageContext'

// TODO: This should probably just be swapped out for a generic alert modal
export const BasketClearRequiredAlert: React.FC<{
  onCancel: () => void
  onSubmit: () => void
}> = ({ onCancel, onSubmit }) => {
  const { t } = useTranslation('menuItem')
  const basketItems = useBasketItems()
  const { basketOutletId } = useBasketOutletId()
  const { urlPath } = useMarketplace()
  const navigate = useNavigate()
  const {
    outletFulfilment: {
      outlet,
      data: { currentFulfilment },
    },
  } = useOutletPageContext()

  const { data: basketOutletData, loading } = useOutletFulfilmentData({
    outletId: basketOutletId || undefined,
    fulfilmentLocation: currentFulfilment.location,
  })

  const handleSubmit = () => {
    basketItems.clear({ shouldResetCheckoutRouter: false })
    onSubmit()
  }

  if (loading) return <LoadingSpinner />

  const handleGoBack = () => {
    if (basketOutletData?.outlet) {
      navigate(
        `/${urlPath}/${basketOutletId}/${convertToSlug(
          basketOutletData.outlet.displayName
        )}/menu`
      )
    }
  }

  return (
    <>
      <Underlay onClick={onCancel} />
      <Container>
        <Title>
          {t('new_order_title', {
            current_outlet: outlet.displayName,
          })}
        </Title>
        <SubTitle>{t('new_order_description')}</SubTitle>
        <ButtonContainer>
          <StyledButton
            buttonType={ButtonType.PRIMARY}
            content={t('new_order_confirm')}
            onClick={handleSubmit}
          />
          {basketOutletData?.outlet ? (
            <StyledButton
              buttonType={ButtonType.SECONDARY}
              content={t('take_me_back', {
                previous_outlet: basketOutletData.outlet.displayName,
              })}
              onClick={handleGoBack}
            />
          ) : null}
          <StyledButton
            buttonType={ButtonType.TERTIARY}
            content={t('cancel')}
            onClick={onCancel}
          />
        </ButtonContainer>
      </Container>
    </>
  )
}
